import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { parseQuery, compileQuery } from 'utils';

function ChessLinkContainer({ className, prevLocation, match = {}, children, query }) {
  const { url } = match;
  const prev = parseQuery(prevLocation);
  const filters = sessionStorage.getItem('filtersUrl');
  const { priceMin, priceMax, costMin, costMax, areaFrom, areaTo, interior, view_type } = filters ? parseQuery(filters.slice(2)) : {};

  const filtersSearch = compileQuery({
    priceMin,
    priceMax,
    costMin,
    costMax,
    areaFrom,
    areaTo,
    interior,
    view_type,
    ...prev
  });
  return (
    <Link className={className} to={`${url}/chess?${query}&${filtersSearch}`}>
      {children}
    </Link>
  );
}

const prevLocationSelector = state => state.building.prevLocation;

const mapStateToProps = (state) => ({
  prevLocation: prevLocationSelector(state)
});

export default withRouter(connect(mapStateToProps)(ChessLinkContainer));



// WEBPACK FOOTER //
// ./src/components/Building/Main/ChessLinkContainer/ChessLinkContainer.js